export interface Category {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-flashlight-line', description: '东方玄幻、异界大陆，热血修炼之路', count: 12580 },
  { slug: 'yanqing', name: '言情', icon: 'ri-heart-line', description: '古代言情、现代都市，浪漫爱情故事', count: 9800 },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line', description: '都市生活、职场风云，贴近现实人生', count: 7560 },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '星际航行、未来世界，探索无限可能', count: 4320 },
  { slug: 'xianxia', name: '仙侠', icon: 'ri-moon-line', description: '修仙问道、侠义江湖，古典仙侠世界', count: 6890 },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '推理探案、惊悚悬疑，烧脑刺激体验', count: 3650 },
  { slug: 'lishi', name: '历史', icon: 'ri-ancient-gate-line', description: '穿越历史、权谋争霸，再现风云时代', count: 5120 },
  { slug: 'youxi', name: '游戏', icon: 'ri-gamepad-line', description: '游戏竞技、虚拟现实，热血电竞之旅', count: 2980 },
];

export interface Article {
  id: string;
  title: string;
  author: string;
  category: string;
  cover: string;
  summary: string;
  content: string;
  rating: number;
  readers: string;
  tags: string[];
  publishDate: string;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '九天星辰诀',
    author: '风凌天下',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystical%20ancient%20Chinese%20warrior%20in%20flowing%20robes%20standing%20atop%20a%20mountain%20peak%20under%20starry%20night%20sky%2C%20golden%20energy%20swirling%2C%20epic%20cinematic%20lighting%2C%20warm%20golden%20and%20crimson%20tones%2C%20soft%20gradient%20background&width=800&height=600&seq=article-cover-01&orientation=landscape',
    summary: '少年秦星辰，偶得九天星辰诀，从此踏上逆天修行之路。星辰之力，浩瀚无边；九天之上，谁主沉浮？',
    content: '第一章 星辰之力\n\n夜幕降临，秦星辰盘膝坐在后山悬崖边，望着漫天繁星，心中涌起一股莫名的悸动。\n\n他已经在这个世界生活了十六年，却始终感觉自己与这个世界格格不入。\n\n"星辰之力..."他低声呢喃，手中紧握着那块从古墓中得到的玉佩。\n\n玉佩在月光下泛着淡淡的蓝光，上面刻着古朴的文字。秦星辰已经研究了三年，终于在今天参透了其中的奥秘。\n\n九天星辰诀，据传是上古时期一位大能所创的绝世功法。修炼至大成，可引动星辰之力，举手投足间毁天灭地。\n\n秦星辰深吸一口气，按照玉佩中记载的法门，开始引导体内微弱的气息。渐渐地，天空中的星光仿佛受到了牵引，一缕缕肉眼可见的光丝从天而降，没入他的体内。\n\n温暖、强大、浩瀚——这是秦星辰此刻的感受。\n\n他知道，自己终于踏上了那条通往巅峰的道路。\n\n第二章 初露锋芒\n\n三个月后，秦家年度大比。\n\n"秦星辰，你确定要参加？"秦家大长老看着眼前这个曾经被称为废物的小辈，语气中带着一丝不屑。\n\n"确定。"秦星辰平静地回答。\n\n比试场上，秦星辰面对的是秦家年轻一辈的第一天才——秦凌云。\n\n"三招之内，你必败！"秦凌云冷笑。\n\n然而，当秦星辰释放出体内那股浩瀚的星辰之力时，在场所有人都震惊了。\n\n仅仅一招，秦凌云便倒飞而出，重重地摔在地上。\n\n全场鸦雀无声。\n\n这一刻，所有人都明白——秦家的天，要变了。',
    rating: 9.6,
    readers: '1280万',
    tags: ['玄幻', '修炼', '热血', '逆袭'],
    publishDate: '2025-03-15',
  },
  {
    id: 'article-2',
    title: '一世倾城',
    author: '苏小暖',
    category: 'yanqing',
    cover: 'https://readdy.ai/api/search-image?query=A%20graceful%20ancient%20Chinese%20woman%20in%20flowing%20silk%20dress%20standing%20among%20cherry%20blossoms%20in%20soft%20golden%20sunlight%2C%20dreamy%20romantic%20atmosphere%2C%20warm%20pink%20and%20cream%20tones%2C%20soft%20ethereal%20lighting&width=800&height=600&seq=article-cover-02&orientation=landscape',
    summary: '她本是京城第一才女，却因一场阴谋流落民间。他是一国储君，却为她不恋江山。一世倾城，只为你一人。',
    content: '第一章 初见\n\n京城三月，桃花盛开。\n\n沈清颜坐在闺房中，手中绣着一方锦帕。她是沈家嫡女，京城第一才女，琴棋书画无一不精。\n\n"小姐，太子殿下来了！"丫鬟翠儿急匆匆地跑进来。\n\n沈清颜手一抖，针尖刺破了指尖，一滴血珠落在锦帕上，晕开一朵小小的红花。\n\n她从未想过，这一见，便是万劫不复。\n\n太子萧瑾瑜，温润如玉，风华绝代。他站在桃花树下，花瓣纷飞间，回眸一笑，仿佛整个世界都亮了起来。\n\n"沈小姐，久仰大名。"他的声音如同春风拂过湖面。\n\n那一刻，沈清颜知道，自己的心，已经不再属于自己。\n\n第二章 变故\n\n然而命运弄人。\n\n一场惊天阴谋，沈家被陷害谋反，满门抄斩。沈清颜九死一生逃出京城，流落民间。\n\n她隐姓埋名，在一座小镇开了一间小小的绣坊。她以为此生再也不会与那个人有任何交集。\n\n直到那一天——\n\n一队人马停在了绣坊门前。为首的男人翻身下马，掀开斗笠，露出一张她朝思暮想的面容。\n\n"清颜，我找了你三年。"萧瑾瑜的声音沙哑，"跟我回去，我要你成为我的太子妃。"\n\n沈清颜泪如雨下。',
    rating: 9.5,
    readers: '960万',
    tags: ['言情', '古言', '权谋', '甜宠'],
    publishDate: '2025-02-20',
  },
  {
    id: 'article-3',
    title: '都市超级医圣',
    author: '断桥残雪',
    category: 'dushi',
    cover: 'https://readdy.ai/api/search-image?query=A%20young%20confident%20doctor%20in%20white%20coat%20standing%20in%20a%20modern%20urban%20cityscape%20with%20glass%20skyscrapers%2C%20warm%20sunset%20lighting%2C%20medical%20cross%20symbol%20glowing%20subtly%2C%20sophisticated%20professional%20atmosphere&width=800&height=600&seq=article-cover-03&orientation=landscape',
    summary: '山村少年身怀绝世医术，进城闯荡，一手银针定生死，一身医术惊天下。看小小村医如何一步步成为都市传奇！',
    content: '第一章 初到江海\n\n林峰背着一个破旧的行囊，站在江海市火车站的广场上，看着车水马龙的繁华都市，心中感慨万千。\n\n"江海，我来了。"\n\n他从小跟着师父在山里学医，如今师父仙逝，留下一封信让他来江海寻找故人之女。\n\n刚走出火车站，林峰就看见一群人围在路边。他挤进去一看，一位老者倒在地上，面色发紫，显然是心脏病突发。\n\n"都让开！我是医生！"一个西装革履的中年男人蹲下来检查，"不行，来不及送医院了，准备心肺复苏。"\n\n"等等。"林峰走上前，"你这样按，他活不过三分钟。"\n\n"你是什么人？"中年医生皱眉。\n\n"我也是医生。"林峰说着，从怀中取出一个布袋，里面是一排银针。\n\n在所有人惊讶的目光中，林峰手起针落，七根银针精准地刺入老者胸前七处穴位。\n\n不到三十秒，老者的脸色开始好转，呼吸逐渐平稳。\n\n"这...这不可能！"中年医生瞪大了眼睛。\n\n林峰收起银针，转身离开。他不知道，这一幕被路人拍下传到了网上，一夜之间，"神秘银针少年"的视频火遍全网。',
    rating: 9.3,
    readers: '850万',
    tags: ['都市', '医术', '逆袭', '爽文'],
    publishDate: '2025-01-10',
  },
  {
    id: 'guide-1',
    title: 'po18官网app下载安装完整指南',
    author: 'po18官方',
    category: 'guide',
    cover: 'https://readdy.ai/api/search-image?query=A%20clean%20modern%20smartphone%20with%20a%20reading%20app%20interface%20displayed%20on%20screen%20showing%20a%20digital%20bookshelf%2C%20placed%20on%20a%20warm%20wooden%20desk%20with%20soft%20natural%20light%2C%20minimal%20aesthetic%2C%20warm%20neutral%20tones&width=800&height=600&seq=guide-cover-01&orientation=landscape',
    summary: '本指南详细介绍po18官网app的下载方法、安装步骤和基础使用教程，帮助新用户快速上手。',
    content: '一、下载前准备\n\n在下载po18官网app之前，请确保：\n\n1. 您的手机系统版本满足最低要求（安卓5.0以上，iOS 12.0以上）\n2. 手机剩余存储空间大于200MB\n3. 网络连接正常\n4. 安卓用户需要在设置中允许"安装未知来源应用"\n\n二、安卓版下载步骤\n\n1. 打开手机浏览器，访问po18官方网站\n2. 在首页找到"安卓版下载"按钮并点击\n3. 等待APK文件下载完成\n4. 点击通知栏中的下载完成提示，或进入文件管理器找到下载的APK文件\n5. 点击安装，按照系统提示完成安装\n\n三、苹果版下载步骤\n\n1. 打开iPhone/iPad上的App Store\n2. 在搜索栏输入"po18"\n3. 找到官方应用（开发者：po18官方）\n4. 点击"获取"按钮进行下载安装\n5. 安装完成后，在主屏幕上找到po18图标即可使用\n\n四、注册与登录\n\n1. 打开po18官网app\n2. 点击"注册"按钮\n3. 输入手机号获取验证码\n4. 设置登录密码\n5. 完成注册后即可登录使用\n\n五、常见问题\n\nQ：安装时提示"安装包解析错误"怎么办？\nA：请删除已下载的APK文件，重新从官方网站下载最新版本。\n\nQ：苹果手机搜索不到po18？\nA：请检查App Store账号区域是否为中国大陆，或尝试切换网络后重新搜索。',
    rating: 9.9,
    readers: '350万',
    tags: ['使用指南', '下载教程', '安装教程'],
    publishDate: '2025-06-01',
  },
  {
    id: 'guide-2',
    title: 'po18官网app核心功能详解与使用技巧',
    author: 'po18官方',
    category: 'guide',
    cover: 'https://readdy.ai/api/search-image?query=A%20tablet%20displaying%20a%20digital%20reading%20app%20with%20various%20features%20like%20bookmarks%20and%20highlights%20on%20a%20clean%20desk%2C%20warm%20natural%20lighting%2C%20modern%20minimal%20design%2C%20cozy%20reading%20atmosphere&width=800&height=600&seq=guide-cover-02&orientation=landscape',
    summary: '深入了解po18官网app的阅读设置、书签管理、离线下载等实用功能，提升您的阅读体验。',
    content: '一、阅读设置\n\npo18官网app提供丰富的阅读自定义选项：\n\n1. 字体设置：支持多种字体切换，包括系统默认、宋体、黑体等\n2. 字号调整：从12号到24号共7档可调\n3. 背景主题：提供白色、米黄、护眼绿、夜间黑四种主题\n4. 翻页模式：支持左右滑动、上下滚动、仿真翻页三种模式\n5. 亮度调节：滑动屏幕左侧即可调节阅读亮度\n\n二、书签与笔记\n\n1. 添加书签：阅读时点击屏幕中央，点击书签图标即可保存当前阅读位置\n2. 查看书签：在阅读界面菜单中选择"书签列表"查看所有已添加的书签\n3. 添加笔记：长按文字内容选中后，选择"笔记"即可添加阅读笔记\n4. 导出笔记：在"我的-笔记"中可将笔记导出为文本文件\n\n三、离线下载\n\n1. 在小说详情页点击"下载"按钮\n2. 选择需要下载的章节范围\n3. 支持WiFi-only下载设置（在设置中开启可节省流量）\n4. 下载的小说存储在"我的-下载管理"中\n5. 可设置自动清理已读章节以节省空间\n\n四、个性化推荐\n\n1. 首页"猜你喜欢"根据阅读历史智能推荐\n2. "榜单"页面展示热搜、好评、新书等多维度排行\n3. "分类"页面支持按类型、字数、状态等多条件筛选\n4. 对不感兴趣的内容可长按选择"不感兴趣"来优化推荐',
    rating: 9.8,
    readers: '280万',
    tags: ['使用指南', '功能教程', '技巧'],
    publishDate: '2025-05-20',
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getArticleById = (id: string): Article | undefined => {
  return articles.find((a) => a.id === id);
};